export default "/images/8287587f66ddbfd3aeec9e5b70947c32.avif";